<div class="st-clipboard-source-chooser-modal-header">
    <mat-icon class="material-icons-outlined">warning_amber</mat-icon>
    <div class="st-clipboard-source-chooser-modal-title">{{ languageSettings.PSTWebClipboardModalTitle }}</div>
</div>
<mat-radio-group
    class="st-clipboard-source-chooser-modal-radio-btn"
    [(ngModel)]="selectedClipboardSource">
    <mat-radio-button
        *ngIf="nomWebServicesJson.HelloResults.PersonalExportFormatTemplates[type]"
        [value]="nomWebServicesJson.HelloResults.PersonalExportFormatTemplates">
        {{ languageSettings.PSTWebClipboardModalPersonal }}
    </mat-radio-button>
    <mat-radio-button
        *ngIf="nomWebServicesJson.HelloResults.TeamExportFormatTemplates[type]"
        [value]="nomWebServicesJson.HelloResults.TeamExportFormatTemplates">
        {{ languageSettings.PSTWebClipboardModalTeam }}
    </mat-radio-button>
    <mat-radio-button
        *ngIf="nomWebServicesJson.HelloResults.EnterpriseExportFormatTemplates[type]"
        [value]="nomWebServicesJson.HelloResults.EnterpriseExportFormatTemplates">
        {{ languageSettings.PSTWebClipboardModalEnterprise }}
    </mat-radio-button>
</mat-radio-group>
<div class="st-clipboard-source-chooser-modal-footer">
    <button
        mat-button
        class="st-clipboard-source-chooser-modal-cancel-btn"
        color="secondary"
        (click)="close()">
        {{ languageSettings.PSTWebCancelButtonLabel }}
    </button>
    <button
        mat-raised-button
        color="primary"
        (click)="applyType()">
        {{ languageSettings.PSTWebApplyButtonLabel }}
    </button>
</div>
